const COPY = {
  cta1: {
    analytics: {
      marketingAnalyticsEvent: {
        action: 'request_demo',
        tag: 'button',
        context: 'CTAs',
        location: 'hero',
      },
    },
  },
  cta2: {
    analytics: {
      marketingAnalyticsEvent: {
        action: 'see_plans_pricing',
        tag: 'button',
        context: 'CTAs',
        location: 'hero',
      },
    },
  },
  bentos: [
    {
      link: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'explore_secret_protection',
            tag: 'link',
            context: 'CTAs',
            location: 'hero',
          },
        },
      },
    },
    {
      link: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'explore_code_security',
            tag: 'link',
            context: 'CTAs',
            location: 'hero',
          },
        },
      },
    },
  ],
} as const

export default COPY
